const Inputs = {
  AlgemeenArray: [
    {
      name: "Is al gekocht",
      data_key: "Is_Al_Gekocht",
      data_type: "select",
      select_items_name: "IsAlGekocht",
    },
    {
      name: "Pas Uitgekomen",
      data_key: "PasUitgekomen",
      data_type: "checkbox",
    },
    {
      name: "Model ID",
      data_key: "ModelID",
      data_type: "input",
      readonly: true,
      color: "red",
    },
    {
      name: "Fabrikant",
      data_key: "naam",
      data_type: "autocomplete",
      select_items_name: "Fabrikanten",
      checkvalue: true,
    },
    {
      name: "Artikelnummer Fabrikant",
      data_key: "FabrikantNummer",
      data_type: "input",
    },
    {
      name: "Omschrijving Fabrikant",
      data_key: "FabrikantOmschrijving",
      data_type: "input",
      multiline: true,
    },
    {
      name: "Unimog Constructie Type (serie)",
      data_key: "TypeID",
      data_type: "select",
      select_items_name: "Serie",
    },
    {
      name: "Unimog-typenummer",
      data_key: "ModelnrID",
      data_type: "select",
      select_items_name: "Type",
    },
    {
      name: "Verhouding",
      data_key: "SchaalID",
      data_type: "select",
      select_items_name: "Verhouding",
    },
    {
      name: "Materiaal",
      data_key: "MateriaalID",
      data_type: "select",
      select_items_name: "Materiaal",
    },
    {
      name: "Toepassing",
      data_key: "ToepassingID",
      data_type: "select",
      select_items_name: "Toepassing",
    },
    {
      name: "Gemaakt Van",
      data_key: "GemaaktVan",
      data_type: "input",
    },
    {
      name: "Gemaakt Tot",
      data_key: "GemaaktTot",
      data_type: "input",
    },
    {
      name: "Exportlanden",
      data_key: "Exportlanden",
      data_type: "input",
    },
    {
      name: "Verkoop In Winkel",
      data_key: "VerkoopInWinkel",
      data_type: "select",
      select_items_name: "VerkoopInWinkel",
    },
    {
      name: "Aantal Stuks",
      data_key: "AantalStuks",
      data_type: "input",
    },
    {
      name: "Nummer Aantal Gemaakt",
      data_key: "Nummer_AantalStuks",
      data_type: "input",
    },
    {
      name: "Verzamel Katalogus Nr",
      data_key: "VerzamelKatalogusNr",
      data_type: "input",
    },
  ],

  KenmerkenArray: [
    {
      name: "Wielafstand",
      data_key: "Wielafstand",
      data_type: "select",
      select_items_name: "Wielafstand",
    },
    {
      name: "Uitvoering Cabine",
      data_key: "UitvoeringCabine",
      data_type: "select",
      select_items_name: "UitvoeringCabine",
    },
    {
      name: "Achteruitkijkspiegel",
      data_key: "Achteruitkijkspiegel",
      data_type: "select",
      select_items_name: "Achteruitkijkspiegel",
    },
    {
      name: "Voorruit",
      data_key: "Voorruit",
      data_type: "select",
      select_items_name: "Voorruit",
    },
    {
      name: "Stuur",
      data_key: "Stuur",
      data_type: "select",
      select_items_name: "Stuur",
    },
    {
      name: "Stoelen",
      data_key: "Stoelen",
      data_type: "select",
      select_items_name: "Stoelen",
    },
    {
      name: "Bestuurder",
      data_key: "Bestuurder",
      data_type: "select",
      select_items_name: "Bestuurder",
    },
    {
      name: "Deuren",
      data_key: "Deuren",
      data_type: "select",
      select_items_name: "Deuren",
    },
    {
      name: "Zwaailicht",
      data_key: "Zwaailicht",
      data_type: "select",
      select_items_name: "Zwaailicht",
    },
    {
      name: "Reservewiel",
      data_key: "Reservewiel",
      data_type: "select",
      select_items_name: "Reservewiel",
    },
    {
      name: "Trekhaak",
      data_key: "Trekhaak",
      data_type: "select",
      select_items_name: "Trekhaak",
    },
    {
      name: "Opschriften",
      data_key: "Opschriften",
      data_type: "input",
      multiline: true,
    },
    {
      name: "Kwaliteit",
      data_key: "NieuwStaat",
      data_type: "select",
      select_items_name: "Kwaliteit",
    },
  ],

  KleurenArray: [
    {
      name: "Kleur Algemeen",
      data_key: "KleurGeheleVoertuig",
      data_type: "autocomplete",
      data_soort: "Kleuren",
      select_items_name: "kleuren",
    },
    {
      name: "Kleur Cabine",
      data_key: "KleurCabine",
      data_type: "autocomplete",
      data_soort: "Kleuren",
      select_items_name: "kleuren",
    },
    {
      name: "Kleur Laadbak",
      data_key: "KleurLaadbak",
      data_type: "autocomplete",
      data_soort: "Kleuren",
      select_items_name: "kleuren",
    },
    {
      name: "Kleur Laadbak Binnenzijde",
      data_key: "KleurLaadbakBinnen",
      data_type: "autocomplete",
      data_soort: "Kleuren",
      select_items_name: "kleuren",
    },
    {
      name: "Kleur Opbouw",
      data_key: "KleurOpbouw",
      data_type: "autocomplete",
      data_soort: "Kleuren",
      select_items_name: "kleuren",
    },
    {
      name: "Kleur Chassis",
      data_key: "KleurChassis",
      data_type: "autocomplete",
      data_soort: "Kleuren",
      select_items_name: "kleuren",
    },
    {
      name: "Kleur Velgen",
      data_key: "KleurVelgen",
      data_type: "autocomplete",
      data_soort: "Kleuren",
      select_items_name: "kleuren",
    },
    {
      name: "Kleur Banden",
      data_key: "KleurBanden",
      data_type: "autocomplete",
      data_soort: "Kleuren",
      select_items_name: "kleuren",
    },
  ],

  ExtraArray: [
    {
      name: "Eigen opmerkingen",
      data_key: "Opmerkingen",
      data_type: "input",
    },
  ],

  OverigeArray: [
    {
      name: "Ondergrond",
      data_key: "Ondergrond",
      data_type: "input",
    },
    {
      name: "Verpakking",
      data_key: "Verpakking",
      data_type: "select",
      select_items_name: "Verpakking",
    },
    {
      name: "Internet Beschrijving",
      data_key: "InternetBeschrijving",
      data_type: "input",
    },
    {
      name: "InkoopModel",
      data_key: "InkoopModel",
      data_type: "input",
    },
    {
      name: "Nieuwwaarde",
      data_key: "Nieuwwaarde",
      data_type: "input",
    },
    {
      name: "Gekocht op (dd-mm-jjjj)",
      data_key: "GekochtOp",
      data_type: "datum",
    },
    {
      name: "Dubbel (Hoe vaak aanwezig)",
      data_key: "Dubbel",
      data_type: "input",
    },
    {
      name: "Zwiterse Website",
      data_key: "ZwitserseID",
      data_type: "input",
    },
  ],

  AanbouwArray: [
    {
      name: "Toebehoren",
      data_key: "Toebehoren",
      data_type: "input",
    },
    {
      name: "Kleur",
      data_key: "Kleur",
      data_type: "autocomplete",
      select_items_name: "kleuren",
    },
  ],

  SetArray: [
    {
      name: "Model is onderdeel van een set",
      data_key: "PartOfSet",
      data_type: "checkbox",
    },
    {
      name: "set",
      data_key: "ModelSetName",
      data_type: "autocomplete",
      select_items_name: "SetNames",
      multiline: true,
    },
  ],
};

export default Inputs;
